export const spaceRemoveWithLowerCase = (str) => {
    return (str = str.replace(/\s/g, "").toLowerCase());
};
